export default __webpack_public_path__ + "static/media/learnMoreActive.8354401e.png";